<div class="message-popup-wrapper manifest-pod-linked-dialog">
  <div class="message-popup-header">
    <div class="ibc-body-text-large-bold">{{ dialogTitle }}</div>
    <div class="card-action-icons">
      <app-svg-icon
        [iconName]="'close'"
        class="cursor"
        [isStaticSvg]="true"
        [isFrom]="'Popup'"
        (staticIconClicked)="onClose()">
      </app-svg-icon>
    </div>
  </div>

  <div class="message-popup-content">
    @if (bannerMessage) {
      <div class="linked-shipments-banner">
        <app-svg-icon
          [iconName]="'warning'"
          [isStaticSvg]="true"></app-svg-icon>
        <span class="ibc-body-text-medium">{{ bannerMessage }}</span>
      </div>
    }

    <mat-form-field appearance="outline" class="mat-md linked-shipments-search">
      <mat-label>Search Shipment</mat-label>
      <input matInput autocomplete="off" [formControl]="searchControl" />
    </mat-form-field>

    <div
      class="linked-shipments-grid"
      [class.grid-disabled]="isSelectMode && isGridDisabled">
      <table class="linked-shipments-table">
        <thead>
          <tr>
            @if (isSelectMode) {
              <th class="select-column">
                <mat-checkbox
                  [checked]="isAllVisibleSelected"
                  [indeterminate]="isSomeVisibleSelected"
                  [disabled]="isGridDisabled || !visibleShipments.length"
                  (change)="toggleAllVisible($event.checked)">
                </mat-checkbox>
              </th>
            }
            <th class="ibc-body-text-large">Shipment</th>
            <th class="ibc-body-text-large">Bag</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of visibleShipments; trackBy: trackByHawbId">
            @if (isSelectMode) {
              <td class="select-column">
                <mat-checkbox
                  [checked]="selectedIds.has(row.hawbId)"
                  [disabled]="isGridDisabled"
                  (change)="toggleRow(row.hawbId, $event.checked)">
                </mat-checkbox>
              </td>
            }
            <td class="ibc-body-text-medium">{{ row.hawbExt }}</td>
            <td class="ibc-body-text-medium">{{ row.bagExt }}</td>
          </tr>
        </tbody>
      </table>
      @if (!visibleShipments.length && (!isSelectMode || shipments.length)) {
        <div class="linked-shipments-empty ibc-body-text-medium">
          {{ noMatchMessage }}
        </div>
      }
    </div>
  </div>

  <div class="popup-footer">
    <button
      type="button"
      class="ibc-medium-button ibc-secondary-default-button cursor"
      (click)="onClose()">
      <span class="ibc-body-text-regular">{{ popupButtons.Close }}</span>
    </button>
    @if (isSelectMode) {
      <button
        type="button"
        class="ibc-medium-button ibc-primary-default-button"
        [ngClass]="canConfirm ? 'cursor' : ''"
        [disabled]="!canConfirm"
        (click)="onConfirm()">
        <span class="ibc-body-text-regular">{{ popupButtons.Confirm }}</span>
      </button>
    }
  </div>
</div>
